import {Pagination} from '../../../utils/pagination'
import {OrderReportContext} from '../context'
import useGetCustomerGroupDropdown from '../hooks/useGetCustomerGroupDropdown'
import {useGetSalesRepDropdown} from '../hooks/useGetSalesRepDropdown'
import OrderReportHeader from '../sections/header/OrderReportHeader'
import OrderReportTable from '../sections/table/OrderReportTable'

const OrderReport = ({useGetOrdersReportExports}: any) => {
  const {
    ordersReportData,
    isOrdersReportLoading,
    filters,
    hasOrderFilterApplied,
    onSearch,
    onSortingChange,
    onDateChange,
    onChangeSalesRepFilter,
    onPageChange,
    pagination,
    onChangeCustomerGroupFilter,
    onDownloadCSV,
    onProfitPercentageChange,
    onResetFilters,
  } = useGetOrdersReportExports

  const {salesReps, isLoading: isSalesRepDropdownLoading} = useGetSalesRepDropdown()
  const {customerGroups, isLoading: isCustomerGroupsLoading} = useGetCustomerGroupDropdown()

  const contextValues = {
    ordersReportData,
    isOrdersReportLoading,
    filters,
    hasOrderFilterApplied,
    onSearch,
    onSortingChange,
    onDateChange,
    onChangeSalesRepFilter,
    onChangeCustomerGroupFilter,
    onDownloadCSV,
    onProfitPercentageChange,
    onResetFilters,

    salesReps,
    isSalesRepDropdownLoading,

    customerGroups,
    isCustomerGroupsLoading,
  }

  return (
    <OrderReportContext.Provider value={contextValues}>
      <OrderReportHeader />
      <OrderReportTable />
      <Pagination onPageChange={onPageChange} pagination={pagination} />
    </OrderReportContext.Provider>
  )
}

export default OrderReport
